import { ChangeDetectorRef, Component, ElementRef, forwardRef, Input, KeyValueDiffers, OnChanges } from '@angular/core';
import { cloneDeep } from 'lodash';
import moment from 'moment-timezone';
import * as uuid from 'uuid';

import { MediaTypeEnum } from '../../../../Common/Basic/enums/media-type.enum';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';

import { BlockComponent } from '../../../../Common/PageBuilder/components/Block/block.component';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { ClickOutsideService } from '../../../../Common/PageBuilder/services/click-outside.service';

import { EngagementAgeEnum } from '../../../../api/mentions/enum/engagement-age.enum';
import { EngagementEventTypeEnum } from '../../../../api/mentions/enum/engagement-event-type.enum';
import { EngagementDataModel } from '../../../../api/mentions/model/engagement-data.model';
import { ImageApiModel } from '../../../../api/mentions/model/image.api.model';
import { MentionInsightApiModel } from '../../../../api/mentions/model/mention-insight-api.model';
import { MentionModel } from '../../../../api/mentions/model/mention.model';
import { MentionSocialDataModel } from '../../../../api/mentions/model/mention-social-data.model';

import { DynamicMentionListDisplayElementModel } from '../../models/dynamic-mention-list-display-element.model';

@Component({
    selector: 'agpr-dynamic-mention-list-block',
    templateUrl: './dynamic-mention-list-block.component.html',
    styleUrls: ['./dynamic-mention-list-block.component.scss'],
    providers: [
        {
            provide: BlockComponent,
            useExisting: forwardRef(() => DynamicMentionListBlockComponent)
        }
    ],
    standalone: false
})
export class DynamicMentionListBlockComponent extends BlockComponent implements OnChanges {
    @Input() actionMenuTextAlignment: string;
    public readonly messageSeverityEnum = messageSeverityEnum;
    protected _twigData: any = {};

    displayElement: DynamicMentionListDisplayElementModel;
    topicName: string;
    showSectionHeading: boolean = true;

    constructor(
        public differs: KeyValueDiffers,
        public pageBuilderService: AbstractPageBuilderService,
        protected changeDetectorRef: ChangeDetectorRef,
        public clickOutsideService: ClickOutsideService,
        public el: ElementRef
    ) {
        super(differs, pageBuilderService, changeDetectorRef, clickOutsideService, el);
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.displayElement = this.block.displayElement as DynamicMentionListDisplayElementModel;
        this.showSectionHeading = this.twigData.styles.showSectionHeading;
        this.setUpDummyTwigData();
    }

    // This is to set up placeholder mention for twig rendering
    private setUpDummyTwigData(): void {
        const twigData = cloneDeep(this.twigData);
        twigData.styles.accentColor = this.displayElement.styles.accentColor;
        twigData.styles.showSectionHeading = false;
        twigData.mentions = [{
            adValueUsd: 0,
            audienceReach: 0,
            body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. '
                + 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
                + 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. '
                + 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            clipDuration: 0,
            contactName: 'Author Name',
            domainAuthority: 0,
            geographyDisplayString: 'Location',
            images: [{
                isPreferred: true,
                url: 'data:image/svg+xml,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\''
                    + '%20viewBox=\'0%200%20200%20100\'%3E%3Crect%20width=\'200\'%20height=\'100\'%20fill=\'%23ced4da\'/%3E%3C/svg%3E',
            }] as ImageApiModel[],
            mediaType: MediaTypeEnum.ONLINE_NEWS,
            note: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            outletName: 'Outlet Name',
            publishedDate: moment.tz(
                [moment.tz(twigData.styles.timezone).year(), 0, 1],
                twigData.styles.timezone
            ).utc().toDate(),
            sentiment: 0,
            id: uuid.v4(),
            socialData: {
                engagementData: [
                    new EngagementDataModel(EngagementEventTypeEnum.like, [{age: EngagementAgeEnum.latest, count: 0}]),
                    new EngagementDataModel(EngagementEventTypeEnum.quote, [{age: EngagementAgeEnum.latest, count: 0}]),
                    new EngagementDataModel(EngagementEventTypeEnum.reply, [{age: EngagementAgeEnum.latest, count: 0}]),
                    new EngagementDataModel(EngagementEventTypeEnum.share, [{age: EngagementAgeEnum.latest, count: 0}]),
                    new EngagementDataModel(EngagementEventTypeEnum.view, [{age: EngagementAgeEnum.latest, count: 0}]),
                ]
            } as MentionSocialDataModel,
            summary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            title: 'Sample Headline',
            wordCount: 0,
            insights: [{
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                name: 'Insights Name',
                isPreferred: true
            }] as MentionInsightApiModel[],
        } as MentionModel];
        twigData.bodyKeywords = ['lorem','ipsum','dolor','sit','amet','consectetur','adipiscing','elit'];
        this._twigData = twigData;
    }
}
